import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { posSummarySearchSchema } from '../../features/reports/operational-search'
import { PosSummaryPage } from '../../features/reports/pos-summary-page'

export const Route = createFileRoute('/_app/pos-summary')({
  staticData: { crumb: 'posSummary' },
  validateSearch: posSummarySearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'pos.view_shift'),
  component: PosSummaryPage,
})
